'use client';

import { TonWalletKitProvider } from '@ywwwtseng/ton-wallet-kit';
import { WalletKitProvider } from '@ywwwtseng/wallet-kit';
import { initAppKit } from '@ywwwtseng/wallet-kit/utils';
import { bsc, bscTestnet, mainnet, sepolia, solana, solanaDevnet } from '@ywwwtseng/wallet-kit/networks';
import { Logo } from '@/components/common/Logo';

const appKit = initAppKit({
  // telegram miniapp disable ssr, otherwise the wallet will be disconnected
  ssr: false,
  themeMode: 'dark',
  projectId: 'dd034674465ccfc9a1c7d8c93d5477c3',
  networks: process.env.NEXT_PUBLIC_APP_ENV === 'production' ? [bsc, mainnet, solana] : [bscTestnet],
  // https://docs.reown.com/cloud/wallets/wallet-list
  includeWalletIds: process.env.NEXT_PUBLIC_APP_ENV === 'production' ? [
    // Binance Wallet
    '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4',
    // OKX Wallet
    '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709',
    // Bitget Wallet
    '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662',
    // Trust Wallet
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
  ] : [
    // MetaMask Wallet
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96'
  ],
});

export function Provider({
  cookies,
  children,
}: {
  cookies?: string | null;
  children: React.ReactNode;
}) {
  return (
    <WalletKitProvider
      maunalExecuteConnectedCallbacks
      debug={process.env.NODE_ENV === 'development'}
      isMainnet={process.env.NEXT_PUBLIC_APP_ENV === 'production'}
      logo={<Logo width={48} height={48} />}
      appKit={appKit}
      cookies={cookies}
    >
      <TonWalletKitProvider mock={process.env.NODE_ENV === 'development'}>
        {children}
      </TonWalletKitProvider>
    </WalletKitProvider>
  );
}
